import { BuildCircle, DateRange, FormatListNumbered, MedicalInformation, PendingActions, RoomPreferences, RouteOutlined, Rule } from "@mui/icons-material";
import { Box, CssBaseline, styled } from "@mui/material";
import { Route, Routes, useLocation } from "react-router-dom";
import AppBarComponent from "../components/appbar";
import { ProtectedRoutes } from "./private_routes";
import { ExistenciasIndex } from "../views/reportes/existencias/existenciasIndex";
import { AccessRoutes } from "./access_route";
import { TrazabilidadIndex } from "../views/reportes/trazabilidad/trazabilidadIndex";
import InactivityTimer from "../components/timerActivity";
import swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { AUTH_LOGOUT } from "../redux/reducers/auth.reducer";
import { QueryIndex } from "../views/reportes/query/queryIndex";
import { NuevaQuery } from "../views/reportes/query/nuevaQuery";
import { ReporteVisual } from "../views/reportes/query/reporteVisual";
import { EditarQuery } from "../views/reportes/query/editQuery";
import { HistoricoIndex } from "../views/reportes/historico/historicoIndex";
import { ReporteTurnoIndex } from "../views/reportes/turnos/ReporteTurnoIndex";
import { ReporteAperturaLineaIndex } from "../views/reportes/aperturaLinea/ReporteAperturaLineaIndex";
import { ReporteLogisticaIndex } from "../views/reportes/logistica/LogisticaIndex";
import { ReporteCuarentenaIndex } from "../views/reportes/cuarentena/CuarentenaIndex";

export const ReportesRouter = () => {
  const menu_options = [
    {
      id: 1,
      name: "Existencias",
      icon: <FormatListNumbered />,
      redirect: "/reportes/existencias",
    },
    {
      id: 2,
      name: "Historico",
      icon: <DateRange />,
      redirect: "/reportes/historico",
    },
    {
      id: 3,
      name: "Turnos",
      icon: <PendingActions />,
      redirect: "/reportes/turnos",
    },
    {
      id: 4,
      name: "Apertura de Línea",
      icon: <RoomPreferences />,
      redirect: "/reportes/apertura",
    },
    {
      id: 5,
      name: "Logística",
      icon: <Rule />,
      redirect: "/reportes/logistica",
    },
    {
      id: 6,
      name: "Defectivos",
      icon: <MedicalInformation />,
      redirect: "/reportes/defectivos",
    },
    {
      id: 7,
      name: "Trazabilidad",
      icon: <RouteOutlined />,
      redirect: "/reportes/trazabilidad",
    },
    {
      id: 8,
      name: "Personalizado",
      icon: <BuildCircle />,
      redirect: "/reportes/personalizado",
    },
  ];

  const location = useLocation();
  const dispatch = useDispatch();
  let path = location?.pathname.split("/").filter((item) => item !== "");

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }));

  const onInactive = () => {
    swal
      .fire({
        position: "center",
        icon: "warning",
        title: "Tiempo de sesión expirado por inactividad",
        showConfirmButton: false,
        timer: 10000,
      })
      .then(() => {
        dispatch(
          AUTH_LOGOUT()
        );
      });
  }

  return (
    <>
      {path[0] === "reportes" && (
        <Box sx={{ display: "flex" }}>
          <CssBaseline />
          <AppBarComponent
            key={"app_bar_inventario"}
            menuOptions={menu_options}
          />
          <Box component="main" sx={{ flexGrow: 1, p: 0 }}>
            <DrawerHeader />
            <Routes>
              <Route element={<ProtectedRoutes />}>
                <Route
                  key="existencias_index"
                  path="/reportes/existencias"
                  element={
                    <AccessRoutes
                      key={"access_existencias"}
                      permission={"MRP:Reportes:Existencias:*"}
                    >
                      <ExistenciasIndex key='exitencias_module' />
                    </AccessRoutes>
                  }
                />
                <Route
                  key="trazabilidad_index"
                  path="/reportes/trazabilidad"
                  element={
                    <AccessRoutes
                      key={"access_trazabilidad"}
                      permission={"MRP:Reportes:Trazabilidad:*"}
                    >
                      <TrazabilidadIndex key='exitencias_module' />
                    </AccessRoutes>
                  }
                />
                <Route
                  key="querys_index"
                  path="/reportes/personalizado"
                  element={
                    <AccessRoutes
                      key={"access_personalizado"}
                      permission={"MRP:Reportes:personalizado:*"}
                    >
                      <QueryIndex key='query_perzonalizado_module' />
                    </AccessRoutes>
                  }
                />
                <Route
                  key="querys_agregar"
                  path="/reportes/personalizado/nuevo"
                  element={
                    <AccessRoutes
                      key={"access_personalizado_nuevo"}
                      permission={"MRP:Reportes:personalizado:*"}
                    >
                      <NuevaQuery key='query_perzonalizado_nuevo' />
                    </AccessRoutes>
                  }
                />
                <Route
                  key="querys_visual"
                  path="/reportes/personalizado/visual/:id"
                  element={
                    <AccessRoutes
                      key={"access_personalizado_visual"}
                      permission={"MRP:Reportes:personalizado:*"}
                    >
                      <ReporteVisual key='query_perzonalizado_visual' />
                    </AccessRoutes>
                  }
                />
                <Route
                  key="querys_edit"
                  path="/reportes/personalizado/editar/:id"
                  element={
                    <AccessRoutes
                      key={"access_personalizado_edit"}
                      permission={"MRP:Reportes:personalizado:*"}
                    >
                      <EditarQuery key='query_perzonalizado_editar' />
                    </AccessRoutes>
                  }
                />
                <Route
                  key="reporte_historico"
                  path="/reportes/historico"
                  element={
                    <AccessRoutes
                      key={"access_historico"}
                      permission={"MRP:Reportes:Historico:*"}
                    >
                      <HistoricoIndex key='historico_index' />
                    </AccessRoutes>
                  }
                />
                <Route
                  key="reporte_turnos"
                  path="/reportes/turnos"
                  element={
                    <AccessRoutes
                      key={"access_turnos"}
                      permission={"MRP:Reportes:Turnos:*"}
                    >
                      <ReporteTurnoIndex key='turnos_index' />
                    </AccessRoutes>
                  }
                />
                <Route
                  key="reporte_apertura_linea"
                  path="/reportes/apertura"
                  element={
                    <AccessRoutes
                      key={"access_apertura"}
                      permission={"MRP:Reportes:Apertura:*"}
                    >
                      <ReporteAperturaLineaIndex key='apertura_linea_index' />
                    </AccessRoutes>
                  }
                />
                <Route
                  key="reporte_logistica"
                  path="/reportes/logistica"
                  element={
                    <AccessRoutes
                      key={"access_logistica"}
                      permission={"MRP:Reportes:Logistica:*"}
                    >
                      <ReporteLogisticaIndex key='logistica_index' />
                    </AccessRoutes>
                  }
                />
                <Route
                  key="reporte_defectivos"
                  path="/reportes/defectivos"
                  element={
                    <AccessRoutes
                      key={"access_defectivos"}
                      permission={"MRP:Reportes:Defectivos:*"}
                    >
                      <ReporteCuarentenaIndex key='defectivos_index' />
                    </AccessRoutes>
                  }
                />
              </Route>

            </Routes>
            <InactivityTimer key='inactivity_component' onInactive={onInactive} />
          </Box>
        </Box>
      )}
    </>
  );
};
